/**
 * Sugerencias de la lista de la compra: lo que se ha apuntado otras veces en
 * este dispositivo, lo más repetido primero. Se guarda aquí (no en la casa)
 * porque es solo una ayuda para escribir menos.
 */

const CLAVE = 'rzcentral.compra.historial';
const MAXIMO = 80;

export type Historial = Record<string, number>;

/** Para comparar sin mayúsculas ni tildes. */
export const normalizar = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

export function leerHistorial(): Historial {
  try { return JSON.parse(localStorage.getItem(CLAVE) ?? '{}') ?? {}; } catch { return {}; }
}

/** Suma una vez a `nombre`; si hay demasiados, se olvidan los menos usados. */
export function recordar(nombre: string, historial: Historial = leerHistorial()): Historial {
  const clave = Object.keys(historial).find(k => normalizar(k) === normalizar(nombre)) ?? nombre;
  const nuevo = { ...historial, [clave]: (historial[clave] ?? 0) + 1 };
  const recortado = Object.fromEntries(Object.entries(nuevo).sort((a, b) => b[1] - a[1]).slice(0, MAXIMO));
  try { localStorage.setItem(CLAVE, JSON.stringify(recortado)); } catch { /* sin almacenamiento */ }
  return recortado;
}

/**
 * Hasta `cuantas` sugerencias: si se está escribiendo, las que empiezan o
 * contienen el texto; si no, las más usadas. Nunca lo que ya está en la lista.
 */
export function sugerenciasCompra(historial: Historial, enLista: string[], texto: string, cuantas = 8): string[] {
  const ya = new Set(enLista.map(normalizar));
  const t = normalizar(texto);
  return Object.entries(historial)
    .filter(([n]) => !ya.has(normalizar(n)) && (!t || normalizar(n).includes(t)) && normalizar(n) !== t)
    .sort((a, b) => Number(normalizar(b[0]).startsWith(t)) - Number(normalizar(a[0]).startsWith(t)) || b[1] - a[1])
    .slice(0, cuantas)
    .map(([n]) => n);
}
